import React from 'react';
import { withAppBasename } from '../../config/appBase';

// Enhanced Error boundary component for production reliability
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null,
      errorId: null
    };
  }

  static getDerivedStateFromError(error) {
    return { 
      hasError: true,
      errorId: `error_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Enhanced error logging with context
    const errorDetails = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      errorId: this.state.errorId,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      userId: sessionStorage.getItem('pathbuddy_user') ? 
        JSON.parse(sessionStorage.getItem('pathbuddy_user')).email : 'anonymous'
    };
    
    console.error('Application Error:', errorDetails);
    
    // Send to error tracking service in production
    if (process.env.NODE_ENV === 'production') {
      try {
        fetch('/api/errors', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(errorDetails)
        }).catch(e => console.warn('Failed to log error:', e));
      } catch (e) {
        console.warn('Error logging failed:', e);
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  }

  handleGoHome = () => {
    window.location.href = withAppBasename('/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-content">
            <div className="error-icon">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="var(--iv-danger)" strokeWidth="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="var(--iv-danger)" strokeWidth="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="var(--iv-danger)" strokeWidth="2"/>
              </svg>
            </div>
            <h1>Oops! Something went wrong</h1>
            <p>We're sorry for the inconvenience. Please try refreshing the page.</p>
            <div className="error-actions">
              <button
                onClick={this.handleReload}
                className="btn btn-primary"
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleGoHome}
                className="btn btn-secondary"
              >
                Go Home
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && (
              <details className="error-details">
                <summary>Error Details (Development)</summary>
                <pre>{this.state.error && this.state.error.toString()}</pre>
                <pre>{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;